import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Card, Select } from 'antd';
import PropTypes from 'prop-types';
import { setOptionFeedback } from '../../redux/actions/experienceAction';
import { setExperienceSelected } from '../../redux/actions/feedbackActions';
import { setSelectedLocation } from '../../redux/actions/experienceAction';
import { experienceOptions } from './experienceOptions';
import { useMediaQuery } from 'react-responsive';
const { TextArea } = Input;
const { Option } = Select;

const optionDetails = {
  "Office network connectivity": {
    English: {
      description: `Digital Network Services refer to Connectivity to Global or Local Philips Resources (Applications, Servers or Printers).  Please select this option when you would like to share your experience with our service. i.e Wide Area Network, Local Area Network, Internet Browsing and VPN Cisco AnyConnect. For Individual Application performance issues, please refer to Desktop or related Application Services. (Teams, Passwords, Desktop/Laptop Issues, etc)`,
    },
    Japanese: {
      description: `デジタル ネットワーク サービスは、グローバルまたはローカルのフィリップス リソース (アプリケーション、サーバー、プリンター) への接続を指します。このオプションを選択して、サービスに関する体験を共有してください。広域ネットワーク、ローカルエリアネットワーク、インターネット閲覧、VPN Cisco AnyConnectなど。個別のアプリケーションパフォーマンスの問題については、デスクトップまたは関連するアプリケーションサービスを参照してください (Teams、パスワード、デスクトップ/ラップトップの問題など)。`,
    },
    German: {
      description: `Digitale Netzwerkdienste beziehen sich auf die Konnektivität zu globalen oder lokalen Philips-Ressourcen (Anwendungen, Server oder Drucker). Bitte wählen Sie diese Option, wenn Sie Ihre Erfahrungen mit unserem Service teilen möchten, z. B. Weitverkehrsnetz, lokales Netzwerk, Internetsurfen und VPN Cisco AnyConnect. Bei Leistungsproblemen einzelner Anwendungen wenden Sie sich bitte an den Desktop- oder verwandte Anwendungsdienste (Teams, Passwörter, Desktop-/Laptop-Probleme usw.).`,
    },
    French: {
      description: `Les services réseau numériques font référence à la connectivité aux ressources Philips globales ou locales (applications, serveurs ou imprimantes). Veuillez sélectionner cette option si vous souhaitez partager votre expérience avec notre service, par exemple réseau étendu, réseau local, navigation Internet et VPN Cisco AnyConnect. Pour les problèmes de performance des applications individuelles, veuillez vous référer aux services de bureau ou d'application associés (Teams, mots de passe, problèmes de bureau/ordinateur portable, etc.).`,
    },
    Spanish: {
      description: `Los servicios de red digital se refieren a la conectividad a los recursos globales o locales de Philips (aplicaciones, servidores o impresoras). Seleccione esta opción si desea compartir su experiencia con nuestro servicio, es decir, red de área amplia, red de área local, navegación por Internet y VPN Cisco AnyConnect. Para problemas de rendimiento de aplicaciones individuales, consulte los servicios de escritorio o aplicaciones relacionadas (Teams, contraseñas, problemas con la computadora de escritorio/portátil, etc.).`,
    },
    Chinese: {
      description: `数字网络服务是指与全球或本地飞利浦资源（应用程序、服务器或打印机）的连接。请选择此选项以分享您对我们服务的体验，例如广域网、局域网、互联网浏览和 VPN Cisco AnyConnect。对于单个应用程序性能问题，请参阅桌面或相关的应用程序服务（Teams、密码、桌面/笔记本问题等）。`,
    },
    Dutch: {
      description: `Digitale netwerkdiensten verwijzen naar connectiviteit met wereldwijde of lokale Philips-bronnen (applicaties, servers of printers). Selecteer deze optie als u uw ervaring met onze service wilt delen, d.w.z. Wide Area Network, Local Area Network, internetbrowsen en VPN Cisco AnyConnect. Voor problemen met de prestaties van individuele toepassingen verwijst u naar Desktop- of gerelateerde toepassingsservices (Teams, wachtwoorden, desktop-/laptopproblemen, enz.).`,
    },
  },
  "GitHub": {
    English: {
      description: `GitHub is used to manage source code, perform code reviews, and orchestrate continuous integration builds in a controlled environment during development.\nManaging source code refers to version control and baselining of source code and organizing the code to isolate parallel development activities (branch, merge).`,
    },
  },
  "SonarQube": {
    English: {
      description: `SonarQube is a static code analysis solution that helps development teams address software quality defects early in the software development life cycle, and ensure compliance with coding standards.\nSonarQube will only be used for Philips InnerSource projects. These project all reside in the Philips internal organization on GitHub.\nSonarQube doesn't change or alter the source code it processes in any form or matter.`,
    },
  },
  "CodeScene": {
    English: {
      description: `CodeScene is a code analysis and visualization tool. It gives actionable insights to effectively reduce technical debt and deliver clean code by cross referencing contextual factors such as code quality, team dynamics, and delivery output. It can be used in the following different parts of the software development lifecycle:\n1. Analyze a complete code base to determine the best refactoring candidates and indicate which code is vulnerable because of team dynamics.\n2. Determine code health at a pull request. CodeScene can be configured to block pull requests that deteriorate or do not improve code health.\n3. Give feedback on code health when writing code in an IDE.\n4. Only generate code that improves the code health by using an MCP server in combination with an LLM of choice.`,
    },
  },
  "Coverity": {
    English: {
      description: `Coverity is an enterprise-grade tool that finds functional defects and security vulnerabilities early in the software development lifecycle, with high accuracy and broad language support.\nKey benefits:\n1. Lowers remediation costs by catching defects earlier.\n2. Reduces developer effort with fewer false positives and actionable diagnostics.\n3. Enables shift-left security via IDE and CI/CD integration and incremental analysis.\n4. Supports regulatory/safety needs with CWE/OWASP mapping and reporting.`,
    },
  },
  "Artifactory": {
    English: {
      description: `Artifactory is a binary repository manager that stores and manages build artifacts, build inputs, third-party software, and installation sources.\n1. It reduces build frequency by enabling reuse of build results across locations and avoiding duplicate artifacts, saving storage.\n2. Artifacts in Artifactory can be part of the design history file (DHF) and serve as validated sources or DMRs.\n3. Retrieval can include checksum verification against files stored in the PLM system to ensure integrity.\n4. Access to repositories is role-based to enforce security and retention policies; delete/overwrite permissions are controlled per user/group.\n5. Identified roles: Developer (retrieves artifacts for testing/builds), Build Manager (uploads build results and sets attributes), Repository Owner (responsible for repository content), Application Manager (backups, setup, upgrades, maintenance).\n6. Artifactory supports promotion metadata (attributes) and retention controls to meet compliance and lifecycle requirements.`,
    },
  },
  "Azure DevOps": {
    English: {
      description: `Azure DevOps is Philips centralized platform for planning, tracing and delivering software and systems.\n1. Planning: supports Scaled Agile work items (Epics, Features, Stories, Tasks).\n2. Requirements: captures, versions and traces requirements; supports import/export and baselining.\n3. Test & defect management: author/execute/reuse tests, link to requirements, and track defects (integrates with TrackWise).\n4. Source & build: source control, CI builds and code review for versioning and baselining.\n5. Risk management: work items for risks/mitigations with traceability and reporting.\n6. Value: end-to-end traceability, audit history and centralized reporting for compliance and collaboration.`,
    },
  },
};

const locationOptions = [
  "Alajuela",
  "Bangalore",
  "Barueri",
  "Batam",
  "Beijing",
  "Best",
  "Blumenau",
  "Boeblingen",
  "Bogota",
  "Bothell",
  "Brussels (Jette)",
  "Brussels (Zaventem)",
  "Buenos Aires",
  "Bucharest",
  "Cambridge",
  "Cairo",
  "Chennai GBS",
  "Colorado Springs",
  "Copenhagen",
  "Drachten",
  "Dubai",
  "Eindhoven",
  "Espoo",
  "Farnborough",
  "Genova",
  "Guadalajara",
  "Guangzhou",
  "Gurgaon",
  "Haifa",
  "Hamburg",
  "Ho Chi Minh City",
  "Huixquilucan",
  "Istanbul",
  "Jette",
  "Johannesburg",
  "Kolkata",
  "Kuala Lumpur Co. Lab",
  "Lodz",
  "Madrid",
  "Malvern",
  "Milano",
  "Mississauga",
  "Murrysville",
  "Nashville",
  "New Cairo",
  "Oslo",
  "Panama City",
  "Paris",
  "Pittsburgh",
  "Plymouth",
  "Prague",
  "Pune (Baner)",
  "Pune (Chakan)",
  "Pune (Pimpri)",
  "Riyadh",
  "San Juan",
  "Santiago",
  "Seoul",
  "Shanghai",
  "Shanghai Zhang jiang",
  "Shenzhen",
  "Singapore",
  "Stockholm",
  "Suresnes",
  "Suzhou",
  "Suzhou GBS",
  "Sydney",
  "Tokyo",
  "Varginha",
  "Vienna",
  "Warsaw",
  "Zaventem",
  "Zhuhai"
];
// dummy change

const experienceText = {
  "IT Experience Center": {
    English: "Please select your IT Experience Center",
    Japanese: "ITエクスペリエンスセンターを選択してください",
    German: "Bitte wählen Sie Ihr IT Experience Center",
    French: "Veuillez sélectionner votre centre d'expérience informatique",
    Spanish: "Por favor seleccione su centro de experiencia de TI",
    Chinese: "请选择您的IT体验中心",
    Dutch: "Gelieve uw IT Ervaringscentrum te selecteren.",
  },
};

const ExperienceRating = ({ currentOption }) => {
  const dispatch = useDispatch();
  const { feedback } = useSelector((state) => state.experience);
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const selectedLocation = useSelector((state) => state.experience.selectedLocation);
  console.log("Selected location:", selectedLocation);
  // const isLocationSelected = useSelector((state) => state.experience.isLocationSelected);   
  const selectedOptionFeedback = feedback[currentOption];
  const selectedExperience = selectedOptionFeedback?.rating || "";
  const commentValue = selectedOptionFeedback?.comment || "";
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const locationOptionSorted=locationOptions.sort();
  const handleExperienceChange = useCallback(
    (option) => {
      const experienceValue = option.ratingValue;
      dispatch(setOptionFeedback(currentOption, experienceValue, commentValue));
      dispatch(setExperienceSelected(currentOption, true));
    },
    [dispatch, currentOption, commentValue]
  );

  const selectedOption = experienceOptions.find((option, index) => {
    return index + 1 === selectedExperience;
  });

  useEffect(() => {
    const locationFromSession = sessionStorage.getItem("selectedLocation");
    if (locationFromSession && locationFromSession !== "") {
      dispatch(setSelectedLocation(locationFromSession));
      console.log(setSelectedLocation);
      console.log(locationFromSession);
    } else {
      // dispatch(setSelectedLocation(""));
    }
  }, []);


  const handleCommentChange = (e) => {
    const newComment = e.target.value;
    dispatch(setOptionFeedback(currentOption, selectedExperience, newComment));
  };

  const handleLocationChange = (value) => {
    dispatch(setSelectedLocation(value));
  };

  const cardStyle = {
    width: 152,
    height: 244,
    cursor: 'pointer',
    // marginBottom: '12px',
  };

  const { description } =
    optionDetails[currentOption]?.[selectedLanguage] ||
    optionDetails[currentOption]?.English ||
    { description: "" };

  return (
    <>
      <div className='main-container'>

        <div
          style={
            isMobile
              ? {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                marginRight: '4%',
                marginTop: '4%',
              }
              : {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }
          }
        >
          <h4>{currentOption}</h4>

          {currentOption === 'IT Experience Center' && (
            <div style={isMobile ? { width: '100%', marginTop: '2%' } : { marginBottom: '8px' }}>
              <Select
                showSearch
                placeholder="Select a location"
                optionFilterProp="children"
                value={selectedLocation}
                onChange={handleLocationChange}
                style={isMobile ? { width: '100%' } : { width: 240 }}
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {locationOptionSorted.map((location) => (
                  <Option key={location} value={location}>
                    {location}
                  </Option>
                ))}
              </Select>

              <label
                style={{
                  fontWeight: 'bold',
                  display: 'block',
                  fontSize: '12px',
                  marginTop: isMobile ? '4px' : '0',
                }}
              >
                {experienceText['IT Experience Center'][selectedLanguage] ||
                  experienceText['IT Experience Center']['English']}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </div>
          )}
        </div>


        {description && <p style={isMobile ? { padding: '3%', whiteSpace: 'pre-line' } : { padding: '0%', whiteSpace: 'pre-line' }}>{description}</p>}

        <h2 style={{ fontSize: "20px" }}>
          {selectedLanguage === 'Chinese'
            ? `请问您对${currentOption}的整体体验如何？`
            : currentOption === 'Philips Personal Computer systems' && selectedLanguage === 'German'
              ? "Wie ist Ihre Gesamterfahrung mit Ihrem Philips Personal Computer systems?"
              : currentOption === 'ITPortal' && selectedLanguage === 'German'
                ? "Wie ist Ihre Gesamterfahrung mit dem ITPortal?"
                : `${experienceOptions[0]?.Question?.[selectedLanguage] || experienceOptions[0]?.Question?.['English']} ${currentOption}?`
          }
        </h2>



        <div
          className="container"
          style={
            isMobile
              ? { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", width: "100%", padding: "4%" }
              : { display: "flex", flexWrap: "wrap", gap: "12px" }
          }
        >

          {/* {experienceOptions.map((option, index) => (
            <div className="cardcss" key={`wrap-${index}`} style={{ width: isMobile ? "100%" : "auto" }}>
            <Card
  className="maincard"
  size="small"
  bodyStyle={{ padding: 0, marginTop: 0 }}

           
              key={`${index}-${option.values[selectedLanguage] || option.values["English"]}`}
              style={{
                ...cardStyle,
                border:
                  selectedExperience === index + 1 ? "2px solid #d9d9d9" : "2px solid #d9d9d9",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                padding: 0,
                marginTop:'5px',
                overflow: "hidden",
                paddingLeft:"0px",
                paddingRight:"0px",
                
              }}
               
              onClick={() => handleExperienceChange(option, index)}
            >
             <div style={{padding:0,marginTop:'15px',minHeight:'90%'}}>

              <div style={{ display: "flex", justifyContent: "center", width: "100%", paddingLeft:0,paddingRight:0}}>
                <img
                  src={option.icon}
                  alt={`Icon for ${option.values[selectedLanguage] || option.values["English"]}`}
                  style={{ width: 40, height: 40 }}
                />
              </div>

             
              <div
                style={{
                  backgroundColor:
                    selectedExperience === index + 1 ? "#CAD2D8" : "#F6F8F9",
                  width: "100%",
                  height:'200px',
                  paddingLeft:'5%',
                  paddingRight:'5%',
                  marginTop: '10px',
                  paddingTop: "15px",
                  textAlign: "center",
                }}
              >
                <h4 style={{ margin: "0 0 4px 0" }}>
                  {option.values?.[selectedLanguage] || option.values?.["English"]}
                </h4>
                <p style={{ margin: 0 }}>
                  {option.descriptions?.[selectedLanguage] || option.descriptions?.["English"]}
                </p>
                
              </div>
              </div>
            </Card>
           </div>
          ))} */}


          {experienceOptions.map((option, index) => (
            <div
              className="cardcss"
              key={`wrap-${index}`}
              style={{ width: isMobile ? "100%" : "auto" }}
            >
              <Card
                className="maincard"
                size="small"
                bodyStyle={{ padding: 0, marginTop: 0 }}
                key={`${index}-${option.values[selectedLanguage] || option.values["English"]}`}
                style={{
                  ...cardStyle,
                  border: "2px solid #d9d9d9",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: 0,
                  marginTop: "5px",
                  overflow: "hidden",
                  paddingLeft: "0px",
                  paddingRight: "0px",

                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => handleExperienceChange(option, index)}
              >
                <div style={{ padding: 0, marginTop: "15px", minHeight: "90%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    <img
                      src={option.icon}
                      alt={`Icon for ${option.values[selectedLanguage] || option.values["English"]}`}
                      style={{ width: 40, height: 40 }}
                    />
                  </div>

                  <div
                    style={{
                      backgroundColor:
                        selectedExperience === index + 1
                          ? "#D1DDEA"
                          : hoveredIndex === index
                            ? "#E0E8F1"
                            : "#F6F8F9",

                      width: "100%",
                      height: "200px",
                      paddingLeft: "5%",
                      paddingRight: "5%",
                      marginTop: "10px",
                      paddingTop: "15px",
                      textAlign: "center",
                    }}
                  >
                    <h4 style={{ margin: "0 0 4px 0" }}>
                      {option.values?.[selectedLanguage] || option.values?.["English"]}
                    </h4>
                    <p style={{ margin: 0 }}>
                      {option.descriptions?.[selectedLanguage] || option.descriptions?.["English"]}
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          ))}

        </div>


        {selectedExperience && selectedOption && (
          <>
            <div>
              <h4>{selectedOption?.comments?.[selectedLanguage] || selectedOption?.comments?.['English']}</h4>
              <p style={{ fontSize: '14px', color: 'gray', marginBottom: '5px' }}>
                {selectedOption?.optionalText?.[selectedLanguage] || selectedOption?.optionalText?.['English']}
              </p>
              <TextArea
                style={isMobile ? { maxWidth: '96%' } : { maxWidth: '100%' }}
                rows={3}
                value={commentValue}
                onChange={handleCommentChange}
                placeholder={selectedOption?.placeholderText?.[selectedLanguage] || selectedOption?.placeholderText?.['English']}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

ExperienceRating.propTypes = {
  currentOption: PropTypes.string.isRequired,
};

export default ExperienceRating;
